/**
 * Competitive session Courts / Manage tab container.
 * Courts: assignments, next-on-court, waiting list. Manage: scheduled games, partnerships, players.
 * Content is passed as children from CompetitiveSessionPage.
 */
function CourtsTab({ children }) {
  return <>{children}</>;
}

export default CourtsTab;
